<div [ngClass]="{isOpen:isOpen(), noTopPadding: noTopPadding}"
  class="flyout-container" *ngIf="visible">
  <ig-hotspot
    *ngIf="hotspot && hotspot.id && hotspot.content$"
    #iconHotspot
    [mode]="hotspot.position"
    [hotspotId]="hotspot.id"
    [showDismissFamily]="hotspot.dismissFamily"
    [parentHotspot]="hotspot.parent"
    [hotspotFamily]="hotspot.family"
    [hotspotCreated]="hotspot.creation"
  >
    <ig-layout-header-icon
      target
      [iconCls]="icon"
      (onClick)="click()"
      [showBadge]="showBadge"
      [showBadgeAsDot]="showBadgeAsDot"
      [badgeColor]="badgeColor"
      [badgeWasVisible]="badgeWasVisible"
      [badgeCount]="badgeMessages.length"
      [isMenuOpen]="isOpen()"
      [ariaLabel]="ariaLabel"
      ></ig-layout-header-icon>
    <div hotspot>{{ hotspot.content$ | async }}</div>
  </ig-hotspot>


  <ig-layout-header-icon
    *ngIf="!(hotspot && hotspot.id && hotspot.content$)"
    [iconCls]="icon"
    (onClick)="click()"
    [showBadge]="showBadge"
    [showBadgeAsDot]="showBadgeAsDot"
    [badgeColor]="badgeColor"
    [badgeWasVisible]="badgeWasVisible"
    [badgeCount]="badgeMessages.length"
    [isMenuOpen]="isOpen()"
    [ariaLabel]="ariaLabel"
    ></ig-layout-header-icon>

  <div [ngClass]="{isOpen:isOpen(), halfwidth: halfWidth}" class="flyout" #overlay role="dialog" igA11yFocus #overlayFocus="igA11yFocus" [attr.aria-label]="ariaLabel" (keydown.escape)="isOpen.set(false)">
    <ng-content></ng-content>
    <div tabindex="0"><!-- fallback focusable element --></div>
  </div>
</div>
